import React, { Component } from 'react';
import { getTranslatedKey } from '../../Utils/TranslateUtils';
import {
  SVGNewTab,
  InfoContainer,
  InfoTitle,
  InfoParagraph,
  InfoWrapper,
  TitleWrapper,
  HeaderWrapper,
  SeparatorRow,
  ListItem,
  UnorderedList,
  Link,
  CloseInfo,
  CloseInfoIcon
} from './PantallaInfoElements';
import { config } from '../../../config/Config';
import { visorVariables } from '../../Utils/VisorsUtils';
export default class InfoAccessibilitat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverDecreto: false,
      hoverBustia: false,
      hoverContinguts: false,
      hoverInfo: false,
      hoverContinguts2: false,
      hoverReclamar: false
    };
  }

  render() {
    return (
      <InfoContainer id="InfoContainer" infoOpen={this.props.infoOpen} mapHeight={this.props.mapHeight}>
        <HeaderWrapper>
          <TitleWrapper>
            <InfoTitle
              id="InfoTitle"
              aria-label={getTranslatedKey('accessibilitatTitle')}
              title={getTranslatedKey('accessibilitatTitle')}
              fontSizeEnabled={this.props.fontSizeEnabled}>
              {getTranslatedKey('accessibilitatTitle')}
            </InfoTitle>
            <CloseInfo
              title={getTranslatedKey('tancar')}
              onClick={() => this.props.toggleInfo()}
              aria-label={getTranslatedKey('aria_closeInfoAccess')}>
              <CloseInfoIcon title={getTranslatedKey('tancar')} fontSizeEnabled={this.props.fontSizeEnabled}>
                <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
              </CloseInfoIcon>
            </CloseInfo>
          </TitleWrapper>
          <SeparatorRow id="SeparatorRowHeaderCatalog" />
        </HeaderWrapper>

        <InfoWrapper>
          <InfoTitle fontSizeEnabled={this.props.fontSizeEnabled} aria-label={getTranslatedKey('aria_declaracioAccess')}>
            {getTranslatedKey('aria_declaracioAccess')}
          </InfoTitle>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>
            {getTranslatedKey('accessibilitatDeclPar')}
            <br />
            {getTranslatedKey('accessibilitatDeclPar2')}
          </InfoParagraph>
          <InfoTitle fontSizeEnabled={this.props.fontSizeEnabled} aria-label={getTranslatedKey('aria_situacio')}>
            {getTranslatedKey('aria_situacio')}
          </InfoTitle>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('accessibilitatSitPar')}</InfoParagraph>
          <InfoTitle fontSizeEnabled={this.props.fontSizeEnabled} aria-label={getTranslatedKey('aria_contNoAccess')}>
            {getTranslatedKey('aria_contNoAccess')}
          </InfoTitle>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('accessibilitatContingutPar1')}</InfoParagraph>
          <InfoParagraph>{getTranslatedKey('accessibilitatContingutPar2')} </InfoParagraph>
          <InfoParagraph>{getTranslatedKey('accessibilitatContingutPar3')}</InfoParagraph>

          <UnorderedList fontSizeEnabled={this.props.fontSizeEnabled}>
            <ListItem>{getTranslatedKey('accessibilitatContingutLlista1')}</ListItem>
            <ListItem>{getTranslatedKey('accessibilitatContingutLlista2')}</ListItem>
            <ListItem>{getTranslatedKey('accessibilitatContingutLlista3')}</ListItem>
          </UnorderedList>
          <InfoTitle fontSizeEnabled={this.props.fontSizeEnabled} aria-label={getTranslatedKey('aria_preparacio')}>
            {getTranslatedKey('aria_preparacio')}
          </InfoTitle>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>
            {getTranslatedKey('accessibilitatPreparacioPar1')}
            <br />
            {getTranslatedKey('accessibilitatPreparacioPar2')}
            <br />
          </InfoParagraph>
          <InfoParagraph>{getTranslatedKey('accessibilitatPreparacioPar3')}</InfoParagraph>
          <InfoTitle fontSizeEnabled={this.props.fontSizeEnabled} aria-label={getTranslatedKey('aria_comunicacions')}>
            {getTranslatedKey('aria_comunicacions')}
          </InfoTitle>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>
            {getTranslatedKey('accessibilitatComunicacionsPar1')}
            &nbsp;
            <Link
              onMouseEnter={() => this.setState({ hoverBustia: true })}
              onMouseLeave={() => this.setState({ hoverBustia: false })}
              fontSizeEnabled={this.props.fontSizeEnabled}
              target="_blank"
              href={visorVariables.correuSuggeriment}
              aria-label={getTranslatedKey('aria_bustia')}>
              {getTranslatedKey('aria_bustia')}.
              <SVGNewTab isHover={this.state.hoverBustia} id="NewTab" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                <g>
                  <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                  <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                </g>
              </SVGNewTab>
            </Link>
            <br />
            {getTranslatedKey('accessibilitatComunicacionsExemple')}
          </InfoParagraph>
          <UnorderedList fontSizeEnabled={this.props.fontSizeEnabled}>
            <ListItem>{getTranslatedKey('accessibilitatComunicacionsLlista1')}</ListItem>
            <ListItem>{getTranslatedKey('accessibilitatComunicacionsLlista2')}</ListItem>
            <ListItem>{getTranslatedKey('accessibilitatComunicacionsLlista3')}</ListItem>
          </UnorderedList>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('accessibilitatComunicacionsPar2')}</InfoParagraph>
          <InfoTitle fontSizeEnabled={this.props.fontSizeEnabled} aria-label={getTranslatedKey('aria_solicituds')}>
            {getTranslatedKey('aria_solicituds')}
          </InfoTitle>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>
            {getTranslatedKey('accesibilitatQueixesPar1')}{' '}
            <Link
              onMouseEnter={() => this.setState({ hoverContinguts: true })}
              onMouseLeave={() => this.setState({ hoverContinguts: false })}
              fontSizeEnabled={this.props.fontSizeEnabled}
              target="_blank"
              href={config.url_contingutAccessible}
              aria-label={getTranslatedKey('aria_contingutAcces')}>
              {getTranslatedKey('aria_contingutAcces')}
              <SVGNewTab isHover={this.state.hoverContinguts} id="NewTab" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                <g>
                  <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                  <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                </g>
              </SVGNewTab>
            </Link>
            {getTranslatedKey('accesibilitatQueixesPar2')}
            <Link
              onMouseEnter={() => this.setState({ hoverInfo: true })}
              onMouseLeave={() => this.setState({ hoverInfo: false })}
              fontSizeEnabled={this.props.fontSizeEnabled}
              target="_blank"
              href={config.url_solicitaInfo}
              aria-label={getTranslatedKey('aria_solicitarInfo')}>
              {getTranslatedKey('aria_solicitarInfo')}
              <SVGNewTab isHover={this.state.hoverInfo} id="NewTab" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                <g>
                  <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                  <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                </g>
              </SVGNewTab>
            </Link>
            ”. <br />
            {getTranslatedKey('accesibilitatQueixesPar3')}
            <br />
            {getTranslatedKey('accesibilitatQueixesPar4')}
          </InfoParagraph>
          <InfoTitle fontSizeEnabled={this.props.fontSizeEnabled} aria-label={getTranslatedKey('aria_procediment')}>
            {getTranslatedKey('aria_procediment')}
          </InfoTitle>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>
            {getTranslatedKey('accesibilitatAplicacioPar1')}
            <Link
              onMouseEnter={() => this.setState({ hoverContinguts2: true })}
              onMouseLeave={() => this.setState({ hoverContinguts2: false })}
              fontSizeEnabled={this.props.fontSizeEnabled}
              target="_blank"
              href={config.url_contingutAccessible}
              aria-label={getTranslatedKey('aria_contingutAcces')}>
              {getTranslatedKey('aria_contingutAcces')}
              <SVGNewTab isHover={this.state.hoverContinguts2} id="NewTab" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                <g>
                  <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                  <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                </g>
              </SVGNewTab>
            </Link>
            {getTranslatedKey('accesibilitatAplicacioPar2')}
            <Link
              onMouseEnter={() => this.setState({ hoverReclamar: true })}
              onMouseLeave={() => this.setState({ hoverReclamar: false })}
              fontSizeEnabled={this.props.fontSizeEnabled}
              target="_blank"
              href={config.url_reclamaSolicitud}
              aria-label={getTranslatedKey('aria_reclama')}>
              {getTranslatedKey('aria_reclama')}
              <SVGNewTab isHover={this.state.hoverReclamar} id="NewTab" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                <g>
                  <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                  <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                </g>
              </SVGNewTab>
            </Link>
            ”. <br />
            {getTranslatedKey('accesibilitatAplicacioPar3')}
          </InfoParagraph>
          <UnorderedList fontSizeEnabled={this.props.fontSizeEnabled}>
            <ListItem>{getTranslatedKey('accesibilitatAplicacioLlista1')}</ListItem>
            <ListItem>{getTranslatedKey('accesibilitatAplicacioLlista2')}</ListItem>
            <ListItem>{getTranslatedKey('accesibilitatAplicacioLlista3')}</ListItem>
          </UnorderedList>
          <InfoParagraph fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('accesibilitatAplicacioPar4')}</InfoParagraph>
        </InfoWrapper>
      </InfoContainer>
    );
  }
}
